import {AppUrls} from 'shared/config/model/urls';
import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {generatePath} from 'react-router-dom';
import cn from 'classnames';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import BackButton from 'shared/ui/IconButton/BackButton';
import {EditButton, PauseButton, DeleteButton, PlayButton, CheckButton} from 'shared/ui/IconButton/iconButtons';
import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';
import useHttpMonitorHeader from 'features/http/model/useHttpMonitorHeader';

import HttpMonitorDeleteModal from '../HttpMonitorDeleteModal/HttpMonitorDeleteModal';
import HttpMonitorPauseModal from '../HttpMonitorPauseModal/HttpMonitorPauseModal';
import HttpMonitorResumeModal from '../HttpMonitorResumeModal/HttpMonitorResumeModal';
import HttpMonitorModal from '../HttpMonitorModal';

import MenuHttpMonitorHeader from './MenuHttpMonitorHeader';

import styles from './HttpMonitorHeader.module.scss';

interface IHttpMonitorHeaderProps {
    item: IHttpMonitorItem,
}

const HttpMonitorHeader: React.FC<IHttpMonitorHeaderProps> = ({item}) => {
    const {
        displayName,
        isCompact,
        editModal,
        deleteModal,
        pauseModal,
        resumeModal,
        onCheckNow,
        onActivate,
        onEditClick,
        onPauseClick,
        onDeleteClick,
    } = useHttpMonitorHeader(item);

    return (
        <div className={styles.container}>
            <div className={cn(
                styles.titleBlock,
                styles.color,
            )}>
                <BackButton
                    to={generatePath(AppUrls.HTTP_MONITORS)}
                    text={t`Назад`}
                />
                <h3>{i18n._(Pages.HTTP_MONITOR_DETAILS)}</h3>
                <div className={styles.name} title={displayName}>
                    «{displayName}»
                </div>
                <EditButton
                    title={t`Редактировать`}
                    iconSize={16}
                    onClick={onEditClick}
                    className={styles.hideMob}
                />
            </div>
            <div className={styles.actionBlock}>
                <div className={styles.actionButtons}>
                    <EditButton
                        title={t`Редактировать`}
                        iconSize={16}
                        onClick={onEditClick}
                        className={styles.hideDeck}
                    />
                    <div className={styles.actionState}>
                        <CheckButton
                            className={cn(styles.actionButton, styles.pause)}
                            title={t`Проверить`}
                            iconSize={16}
                            onClick={onCheckNow}
                            text={t`Проверить`}
                        />
                        {item.status === 'active'
                            ? <PauseButton
                                className={cn(styles.actionButton, styles.pause)}
                                title={t`Приостановить`}
                                iconSize={16}
                                text={!isCompact ? `${t`Приостановить`}` : undefined}
                                onClick={onPauseClick}
                            />
                            : <PlayButton
                                className={cn(styles.actionButton, styles.play)}
                                title={t`Включить`}
                                iconSize={16}
                                text={!isCompact ? `${t`Включить`}` : undefined}
                                onClick={onActivate}
                            />
                        }
                    </div>
                    <DeleteButton
                        className={styles.delete}
                        title={t`Удалить`}
                        iconSize={16}
                        onClick={onDeleteClick}
                    />
                </div>
                <div className={styles.menu}>
                    <MenuHttpMonitorHeader
                        onCheck={onCheckNow}
                        onEdit={onEditClick}
                        onDelete={onDeleteClick}
                        onPause={onPauseClick}
                        onActive={onActivate}
                        status={item.status}
                    />
                </div>
            </div>

            <HttpMonitorModal
                open={editModal.isOpen}
                item={item}
                handleClose={editModal.close}
            />

            <HttpMonitorDeleteModal
                item={item}
                open={deleteModal.isOpen}
                handleClose={deleteModal.close}
            />
            <HttpMonitorPauseModal
                item={item}
                open={pauseModal.isOpen}
                handleClose={pauseModal.close}
            />
            <HttpMonitorResumeModal
                item={item}
                open={resumeModal.isOpen}
                handleClose={resumeModal.close}
                goal="RESUME_MONITOR_DETAIL"
            />
        </div>
    );
};

export default HttpMonitorHeader;